import { render, staticRenderFns } from "./ControlPlanBase.vue?vue&type=template&id=ca55457c&scoped=true"
import script from "./ControlPlanBase.vue?vue&type=script&lang=js"
export * from "./ControlPlanBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca55457c",
  null
  
)

export default component.exports